<template>
  <v-autocomplete
    v-model="value"
    :items="places"
    :loading="loading"
    label="Место"
    dense
    outlined
    clearable
    hide-details
    no-data-text="Нет мест"
    style="max-width: 320px"
  />
</template>

<script>
// Селект места СКУД: значение в $store.state.skud_place, дубль в localStorage 'skud.place'.
// Список мест — общий кэш skud-places-service (place_id Charon == id места vending).
import { loadPlaces } from '@/views/skud/shared/services/skud-places-service'

export default {
  name: 'SkudPlaceSelect',
  data () {
    return {
      places: [],
      loading: false
    }
  },
  computed: {
    value: {
      get () {
        return this.$store.state.skud_place
      },
      set (v) {
        this.$store.commit('skud_place', v)
        if (v === null || v === undefined) {
          localStorage.removeItem('skud.place')
        } else {
          localStorage.setItem('skud.place', v)
        }
      }
    }
  },
  mounted () {
    this.loading = true
    loadPlaces().then(list => {
      this.loading = false
      this.places = list
      const saved = localStorage.getItem('skud.place')
      if (saved !== null && this.places.some(p => p.value === Number(saved))) {
        this.$store.commit('skud_place', Number(saved))
      }
    })
  }
}
</script>
